/**
 * Use to render "nothing" (results in an HTML comment node)
 */
export default {
	name: 'CVoid',
	render (h) {
		return h();
	}
};